import gql from "graphql-tag";

export const REGISTER_MODERATION_ACTIVITY = gql`
  mutation RegisterModerationActivity($input: ModerationActivityInput!) {
    success: registerModerationActivity(input: $input)
  }
`;

export {
  RegisterModerationActivity,
  RegisterModerationActivityVariables
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/mutations/aliexpress/registerModerationActivity.ts